import qs from 'qs';
import React, { FC, useCallback, useEffect, useRef } from 'react';
import { BootParameters, useInternalState } from '..';

export interface BootProps {
	parameters?: BootParameters | null;
	children?: React.ReactNode;
}

// Handle boot when provider is ready
const Boot: FC<BootProps> = ({ parameters, children }) => {
	const internalState = useInternalState();
	const stateRef = useRef(internalState);
	stateRef.current = internalState;

	const [booted, setBooted] = React.useState(false);

	const boot = useCallback(async (parameters: BootParameters | null) => {
		stateRef.current?.dispatch({ type: 'IS_SCENE_LOADING', isLoading: true });

		// Register to environment changes
		stateRef.current?.state.environment.on('change', () => stateRef.current?.dispatch({ type: 'UPDATE' }));
		stateRef.current?.state.environment.on('debugMode', () => stateRef.current?.dispatch({ type: 'DEBUG_MODE' }));
		stateRef.current?.state.environment.on('viewer', (v) => stateRef.current?.dispatch({ type: 'VIEWER', value: v }));

		await stateRef.current?.state.environment.boot(parameters);

		stateRef.current?.dispatch({ type: 'IS_SCENE_LOADING', isLoading: false });
	}, []);

	const handleMessageReceived = useCallback(async (e: MessageEvent) => {
		if (e.data.type == 'load' && !stateRef.current?.state.parametersReceived) {
			stateRef.current?.dispatch({ type: 'PARAMETERS_RECEIVED' });

			boot(e.data.parameters);

			window.parent.postMessage(
				{
					zakekeType: 'loaded',
					message: {
						integrationVersion: 2
					}
				},
				'*'
			);
		}
	}, []);

	useEffect(() => {
		const query = qs.parse(window.location.search);

		if (parameters) {
			console.log('Loading parameters from boot parameters prop...');
			boot(parameters);
		} else if (query && query.ecommerce && (query.ecommerce == 'preview' || query.ecommerce == 'viewer')) {
			console.log('Loading parameters from query string...');
			boot(null);
		} else {
			console.log('Loading parameters from post message...');
			window.addEventListener('message', handleMessageReceived);
		}

		return () => window.removeEventListener('message', handleMessageReceived);
	}, []);

	return <>{children}</>;
};

export default Boot;
